import logo from '../../assets/img/logo.png';
import mobileLogo from '../../assets/img/AO_REWARDS.png';
import styles from './styles.scss';

export  const WelcomeHeader = () => {
    return (
        <header className="site-header">
            <img src={logo} alt="Logo" className="desktop-logo" />

            <img src={mobileLogo} alt="Logo" className="logo d-block-tablet" />
        </header>
    );
}
